<template>
    <MainContent title="Listados bloqueos y aforo">
        <template v-slot:header>
            <h3 class="card-title">Listados bloqueos y aforo</h3>
        </template>
        <template v-slot:content>
            <b-card title="Listado Aforo">
                <b-card-text class="mt-5">
                    <b-table hover :items="ocupacion" :fields="fieldsOcupacion" id="listado-ocupacion"/>
                </b-card-text>
            </b-card>
            <b-card title="Cuadro de bloqueo">
                <b-card-text class="mt-5">
                    <div class="row">
                        <div class="input-group input-group-sm p-2 col-md-9">
                            <input type="search" name="table_search" class="form-control" placeholder="Buscar" v-model="filtros.search" @input="debouncedGetBloqueos()"/>
                    
                            <div class="input-group-append">
                                <Button @click="debouncedGetBloqueos()" type="submit" variant="default" icon="fas fa-search" />
                            </div>
                        </div>
                        <select class="custom-select w-auto mr-3" v-model="filtros.zona_id" @change="debouncedGetBloqueos()">
                            <option value="">Seleciona Region</option>
                            <option v-for="zona in zonas" :value="zona.id" :key="zona">{{ zona.name }}</option>
                        </select>
                    </div>
                    <b-table hover :items="bloqueos.data" :fields="fields" id="abonados-table">
                        <template v-slot:cell(region)="row">
                            <span>{{ row.item.region.name }}</span>
                        </template>
                        <template v-slot:cell(row)="row">
                            <span>{{ row.item.row ? row.item.row : 'Sin Numerar' }}</span>
                        </template>
                        <template v-slot:cell(seat)="row">
                            <span>{{ row.item.seat ? row.item.seat : 'Sin Numerar' }}</span>
                        </template>
                        <template v-slot:cell(concepto)="row">
                            <span>{{ row.item.concepto }}</span>
                        </template>
                        <template v-slot:cell(id)="row">
                            <div class="btn-group">
                                <router-link 
                                    :to="{
                                        name: 'back.abonos.bloquear-asientos',
                                        params: { zona: row.item.region },
                                    }" 
                                    class="btn btn-sm btn-primary"
                                >
                                    Ver region
                                </router-link>
                            </div>
                        </template>
                    </b-table>
                    <div class="d-md-flex">
                        <div class="d-md-flex">
                            <ElementosPorPaginaComponent @input="(n) => numPage = n" :value="numPage" />
                            <b-pagination 
                                v-model="filtros.currentPage"
                                :total-rows="bloqueos.meta.total"
                                :per-page="numPage"
                                first-number
                                last-number
                                @input="debouncedGetBloqueos()"
                            />
                        </div>
                    </div>
                </b-card-text>
            </b-card>
        </template>
    </MainContent>
</template>

<script>
    import MainContent from '@/components/backend/components/MainContent.vue';
    import ElementosPorPaginaComponent from '@/components/backend/components/ElementosPorPaginaComponent.vue';
    export default {
        data() {
            return {
                filtros: {
                    lista_id: this.$store.getters.getListaActiva.id,
                    per_page: 10,
                    page: 1,
                    search: "",
                    zona_id: "",
                    currentPage: 1,
                    rows: 0,
                },
                fields: [
                    { key: "region", label: "Región" },
                    { key: "row", label: "Fila" },
                    { key: "seat", label: "Asiento" },
                    { key: "concepto", label: "Concepto"},
                    { key: "id", label: "Acciones", class: "text-center" }
                ],
                fieldsOcupacion: [
                    {key: "name", label: "Sector"},
                    {key: "aforo", label: "Stock"},
                    {key: "bloqueos", label: "Bloqueos"},
                    {key: "vendidas", label: "Vendidas"},
                    {key: "libres", label: "Libres"},
                ],
                bloqueos: [],
                loading: false,
                debouncedGetBloqueos: null,
                zonas: [],
                ocupacion: [],
                numPage: 5,
            }
        },
        created() {
            this.getOcupacion();
            this.getZonas();
            this.getBloqueos();
            this.debouncedGetBloqueos = _.debounce(this.getBloqueos, 500);
        },
        methods: {
            getBloqueos() {
                this.loading = true;
                var params = {
                    filters : {
                        lista_id: this.filtros.lista_id,
                        zona_id : this.filtros.zona_id,
                        search : this.filtros.search,
                        page : this.filtros.currentPage,
                        per_page : this.numPage,
                    },
                    lista_id : this.filtros.lista_id,
                }


                this.$store.dispatch(this.config.getVuexAlias('back.abonos.listado-bloqueos'), params).then(res => {
                    this.filtros.rows = res.data.meta.last_page;
                    this.filtros.perPage = res.data.meta.per_page > 5 ? res.data.per_page : 1;
                    this.filtros.currentPage = res.data.meta.current_page;
                    this.bloqueos = res.data;
                }).finally(() => this.loading = false);
            },
            getZonas() {
                const params = {
                    filters: {
                        place_id: this.place.id
                    },
                }
                this.$store.dispatch(this.config.getVuexAlias('zonas.index'), params).then(res => {
                    this.zonas = res.data;
                    this.$emit('setZonas', this.zonas);
                });
            },
            getOcupacion(){
                var params = {
                    filters : {
                        place_id: this.place.id
                    },
                    lista_id : this.filtros.lista_id,
                }
                this.$store.dispatch(this.config.getVuexAlias('back.abonos.listado-ocupacion'), params).then(res => {
                    this.ocupacion = res.data.data;
                    let totalObj = {
                        "name": "Total",
                        "aforo": 0,
                        "bloqueos": 0,
                        "vendidas": 0,
                        "libres": 0
                    };
                    this.ocupacion.forEach(zona => {
                        totalObj.aforo += parseInt(zona.aforo);
                        totalObj.bloqueos += parseInt(zona.bloqueos);
                        totalObj.vendidas += parseInt(zona.vendidas);
                        totalObj.libres += parseInt(zona.libres);
                    });
                    this.ocupacion.push(totalObj);
                }).catch(err => {
                    let totalObj = {
                        "name": "Total",
                        "aforo": 0,
                        "bloqueos": 0,
                        "vendidas": 0,
                        "libres": 0
                    };
                    this.ocupacion.push(totalObj);
                });
            },
        },
        computed: {
            place() {
                return this.$store.getters.getRecinto;
            }
        },
        watch: {
            numPage() {
                this.debouncedGetBloqueos();
            },
            currentPage() {
                this.debouncedGetBloqueos();
            },
            search(){
                this.debouncedGetBloqueos();
            }
        },
        components: {
            ElementosPorPaginaComponent, MainContent
        },
    }
</script>